import type { DatasetIconProps } from "./DatasetIcon.type";

import { RiRoadMapFill, RiRoadMapLine } from "react-icons/ri";

const PlanPositioningIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <RiRoadMapFill /> : <RiRoadMapLine />;
};

export default PlanPositioningIcon;
